// src/config/building-map.js
export default {
  // 'L1-1': { label: '1号楼一单元', path: ['jianzhu'] },
  // 'L1-2': { label: '1号楼二单元', path: ['jianzhu'] },
  // 'DM-1': { label: '电缆沟1',     path: ['DM'] },
  // 'top-A': { label: '屋顶 A 区',   path: ['top'] },
  // 以后新楼：按“模型名: {label, path}”再加一行就好
}
